import { useQuery, useMutation } from 'react-query';

import {
  getMambuLedgerConfiguration,
  getMambuLedgerStatus,
  setMambuLedgerConfiguration,
} from '~/api/ledgers';
import { queryClient } from '~/App';
import { MambuConfiguration } from '~/types';

const MAMBU_PREFIX = 'mambu';

export const useGetMambuLedgerStatus = (options?: any) => {
  return useQuery([MAMBU_PREFIX, 'status'], getMambuLedgerStatus, options);
};

const ONE_MINUTE = 10000;
const MAMBU_CONFIGURATION_PREFIX = [MAMBU_PREFIX, 'configuration'];
export const useGetMambuLedgerConfiguration = () => {
  return useQuery(MAMBU_CONFIGURATION_PREFIX, getMambuLedgerConfiguration, {
    staleTime: ONE_MINUTE,
  });
};

const useUpdateGetMambuLedgerConfigurationInternal = () => {
  return (value: MambuConfiguration) => {
    queryClient.setQueryData<MambuConfiguration>(MAMBU_CONFIGURATION_PREFIX, () => value);
  };
};

export const useSetMambuLedgerConfiguration = () => {
  const updateCache = useUpdateGetMambuLedgerConfigurationInternal();
  return useMutation(setMambuLedgerConfiguration, {
    onSuccess: (res) => updateCache(res),
  });
};
